import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=f4a77c3e"
import script from "./Sandbox.vue?vue&type=script&lang=js"
export * from "./Sandbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports